import { Link, useLocation, useNavigate } from "react-router-dom";
import { DandelionSeed } from "@/components/DandelionSeed";

export default function Footer({ onOpenCookieSettings }) {
  const location = useLocation();
  const navigate = useNavigate();

  const goAnchor = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/" + id);
      return;
    }
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative pt-20 pb-10 border-t"
      style={{ background: "var(--cream-deep)", borderColor: "var(--line)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-full flex items-center justify-center"
                style={{ background: "var(--cream)" }}>
                <DandelionSeed size={24} />
              </span>
              <div>
                <p className="font-serif text-2xl" style={{ color: "var(--ink)" }}>Praxis Seelen-Raum</p>
                <p className="text-[11px] tracking-[0.22em] uppercase" style={{ color: "var(--ink-mute)" }}>
                  Petra Fellmann · Heilpraktikerin für Psychotherapie
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-md leading-relaxed text-[15px]" style={{ color: "var(--ink-soft)" }}>
              Ein Raum für Begegnung, Wachstum und sanfte Veränderung.
              Mit Sorgfalt aufgebaut — gemacht für Sie.
            </p>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/praxis_seelenraum_haby/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="mt-6 inline-flex items-center gap-3 px-5 py-3 rounded-full text-sm font-medium text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
              style={{
                background:
                  "linear-gradient(45deg, #FEDA75 0%, #FA7E1E 22%, #D62976 50%, #962FBF 75%, #4F5BD5 100%)",
                boxShadow: "0 10px 30px -10px rgba(214, 41, 118, 0.45)",
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
              </svg>
              @praxis_seelenraum_haby
            </a>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs tracking-[0.22em] uppercase mb-4" style={{ color: "var(--ink-mute)" }}>
              Navigation
            </p>
            <ul className="space-y-2.5 text-[15px]">
              {[
                { l: "Startseite", h: "#hero" },
                { l: "Leistungen", h: "#leistungen" },
                { l: "Abrechnung", h: "#abrechnung" },
                { l: "Über mich", h: "#ueber-mich" },
                { l: "Kontakt", h: "#kontakt" },
              ].map((i) => (
                <li key={i.h}>
                  <a href={i.h} onClick={(e) => goAnchor(e, i.h)} className="soft-link"
                    data-testid={`footer-nav-${i.l.toLowerCase().replace(/\s+/g, "-")}`}>
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.22em] uppercase mb-4" style={{ color: "var(--ink-mute)" }}>
              Rechtliches
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/impressum"
                data-testid="footer-legal-impressum"
                className="inline-flex items-center justify-center px-4 py-2.5 rounded-full border text-sm transition-all duration-300 hover:bg-white"
                style={{ borderColor: "var(--ink)", color: "var(--ink)" }}
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-legal-datenschutz"
                className="inline-flex items-center justify-center px-4 py-2.5 rounded-full border text-sm transition-all duration-300 hover:bg-white"
                style={{ borderColor: "var(--ink)", color: "var(--ink)" }}
              >
                Datenschutz
              </Link>
              <button
                onClick={onOpenCookieSettings}
                data-testid="footer-legal-cookies"
                className="inline-flex items-center justify-center px-4 py-2.5 rounded-full border text-sm transition-all duration-300 hover:bg-white"
                style={{ borderColor: "var(--ink)", color: "var(--ink)" }}
              >
                Cookie Einstellungen
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
          style={{ borderColor: "var(--line)" }}>
          <p className="text-xs" style={{ color: "var(--ink-mute)" }}>
            © {new Date().getFullYear()} Petra Fellmann · Praxis Seelen-Raum · trauma-fellmann.de
          </p>
          <p className="text-xs italic font-serif" style={{ color: "var(--ink-mute)" }}>
            {`„Mit jedem Atemzug ein neuer Anfang."`}
          </p>
        </div>
      </div>
    </footer>
  );
}
